<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('communityManage.confirmDeleteCommunity') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteCommunity">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteCommunity } from '@/api/common/communityManage/communityManageApi'

export default {
  name: 'DeleteCommunity',
  data() {
    return {
      dialogVisible: false,
      deleteCommunityInfo: {}
    }
  },
  methods: {
    open(community) {
      this.dialogVisible = true
      this.deleteCommunityInfo = { ...community }
    },
    handleClose() {
      this.deleteCommunityInfo = {}
    },
    deleteCommunity() {
      deleteCommunity(this.deleteCommunityInfo).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('common.deleteSuccess'))
          this.dialogVisible = false
          this.$emit('deleted')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.error('请求失败:', error)
        this.$message.error(this.$t('common.deleteFailed'))
      })
    }
  }
}
</script>

<style scoped>
.el-dialog__body {
  padding: 20px;
}
</style>